import { createSlice } from "@reduxjs/toolkit";


const getTotalPrice = (cartItems) => {

  let amountValue = 0;
  if (cartItems && cartItems.length > 0) {
    cartItems.map((order) => {
      amountValue += order.product.price * order.count;
    });
  }

  return amountValue;
};



const orderSlice = createSlice({
  name: "order",
  initialState: {
    cartOrders: null,
    cartItemsTotalPrice: 0,

    order: null,
    orders: null,
    filteredOrders: null,
    filter: {
      search: null,
      pagination: null,
    },
    filterOrderCount: [10, 50, 100, 200, 300],
    pagination: null,

    selectedOrders: [],

    selectedpagination: 0,
  },
  reducers: {
    setCartOrders(state, action) {
      state.cartOrders = action.payload;
      state.cartItemsTotalPrice=getTotalPrice(action.payload)
    },

    setOrder(state, action) {
      state.order = action.payload;
    },
    setOrders(state, action) {
      state.orders = action.payload;
    },
    setFilteredItems(state, action) {
      state.filteredOrders = action.payload;
    },
    resetOrders(state) {
      state.orders = null;
      state.filteredOrders = null;
      state.filter = {
        search: null,
        pagination: null,
      };
    },

    setFilter(state, action) {
      if (Array.isArray(action.payload)) {
        action.payload.map((item) => {
          state.filter[item.key] = item.value;
        });
      } else {
        state.filter[action.payload.key] = action.payload.value;
      }
    },
    setPagination(state, action) {
      state.pagination = action.payload;
    },

    removeOrder(state, action) {
      state.orders = state.orders.filter(
        (order) => order.id !== action.payload,
      );
      if (state.filteredProducts) {
        state.filteredOrders = state.filteredOrders.filter(
          (order) => order.id !== action.payload,
        );
      }
    },
    updateOrder(state, action) {
      action.payload.map((item) => {
        state.order[item.key] = item.value;
      });
    },

    updateOrders(state, action) {
      Object.keys(state.orders).forEach((key) => {
        let item = state.orders[key];

        action.payload.ids.map((id) => {
          if (item.id == id) {
            action.payload.changes.map((ch) => {
              if (ch.value !== null) {
                state.orders[key][ch.key] = ch.value;
              }
            });
          }
        });
      });

      if (state.filteredOrders) {
        Object.keys(state.filteredOrders).forEach((key) => {
          let item = state.filteredOrders[key];

          action.payload.ids.map((id) => {
            if (item.id == id) {
              action.payload.changes.map((ch) => {
                if (ch.value !== null) {
                  state.filteredOrders[key][ch.key] = ch.value;
                }
              });
            }
          });
        });
      }
    },

    addOrder(state, action) {
      state.orders = [...state.orders, action.payload];
      state.filteredOrders = [...state.filteredOrders, action.payload];
    },
    onSelectOrder(state, action) {
      if (action.payload.action === "add") {
        state.selectedOrders = [...state.selectedOrders, action.payload.user];
      }
      if (action.payload.action === "remove") {
        state.selectedOrders = state.selectedOrders.filter(
          (user) => user.id !== action.payload.user.id,
        );
      }
    },

    setSelectedPagination(state, action) {
      state.selectedpagination = action.payload;
    },
  },
});

export default orderSlice;

export const orderActions = orderSlice.actions;
